import { Module } from 'vuex'
import { UEFAAPIApi, GetUefaApiCallRequest } from '@rtl/api'
import {
  UEFA_GETTER,
  UEFA_ACTION,
  UefaState,
  UefaScheduleListResult,
  UefaScheduleListPayload,
  UefaScoreListResult,
  UefaScoreListPayload,
  UefaPlayerStatResult,
  UefaPlayerStatPayload,
  UefaTeamStatResult,
  UefaTeamStatPayload
} from './types'
import { API_GETTER, errorHandler } from '../api'

export function createUefaModule<RootState> (namespaced = false): Module<UefaState, RootState> {
  const uefaChampionsLeague2025 = '2mr0u0l78k2gdsm79q56tb2fo'

  return {
    namespaced,
    state () {
      return {}
    },
    getters: {
      [UEFA_GETTER.API]: (state, getters, rootState, rootGetters) => {
        return new UEFAAPIApi(rootGetters[API_GETTER.CONFIG])
      }
    },
    actions: {
      async [UEFA_ACTION.SCHEDULE_LIST] ({ getters, rootGetters }, payload: UefaScheduleListPayload): Promise<UefaScheduleListResult> {
        const queries = Object.entries({
          _rt: 'b',
          _fmt: 'json',
          tmcl: uefaChampionsLeague2025,
          ...payload
        }).map(([key, val]) => `${key}=${val}`)

        const data: GetUefaApiCallRequest = {
          url: `tournamentschedule/{outletAuthKey}?${queries.join('&')}`
        }

        const response = await errorHandler(() => getters[UEFA_GETTER.API].getUefaApiCall({
          ...rootGetters[API_GETTER.PARAMS],
          ...data
        }))

        return response
      },
      async [UEFA_ACTION.SCORE_LIST] ({ getters, rootGetters }, payload: UefaScoreListPayload): Promise<UefaScoreListResult> {
        const queries = Object.entries({
          _rt: 'b',
          _fmt: 'json',
          _ordSrt: 'desc',
          live: 'yes',
          status: 'Played',
          tmcl: uefaChampionsLeague2025,
          ...payload
        }).map(([key, val]) => `${key}=${val}`)

        const data: GetUefaApiCallRequest = {
          url: `match/{outletAuthKey}?${queries.join('&')}`
        }

        const response = await errorHandler(() => getters[UEFA_GETTER.API].getUefaApiCall({
          ...rootGetters[API_GETTER.PARAMS],
          ...data
        }))

        return response
      },
      async [UEFA_ACTION.PLAYER_STAT] ({ getters, rootGetters }, payload: UefaPlayerStatPayload): Promise<UefaPlayerStatResult> {
        const statQueries = Object.entries({
          _rt: 'b',
          _fmt: 'json',
          tmcl: uefaChampionsLeague2025,
          ...payload
        }).map(([key, val]) => `${key}=${val}`)

        const statData: GetUefaApiCallRequest = {
          url: `rankings/{outletAuthKey}?${statQueries.join('&')}`
        }

        const [statResponse] = await Promise.all([
          errorHandler(() => getters[UEFA_GETTER.API].getUefaApiCall({
            ...rootGetters[API_GETTER.PARAMS],
            ...statData
          }))
        ])

        return statResponse
      },
      async [UEFA_ACTION.TEAM_STAT] ({ getters, rootGetters }, payload: UefaTeamStatPayload): Promise<UefaTeamStatResult> {
        const teamsQueries = Object.entries({
          _rt: 'b',
          _fmt: 'json',
          detailed: 'yes',
          tmcl: uefaChampionsLeague2025
        }).map(([key, val]) => `${key}=${val}`)

        const teamsData: GetUefaApiCallRequest = {
          url: `team/{outletAuthKey}?${teamsQueries.join('&')}`
        }

        const statQueries = Object.entries({
          _rt: 'b',
          _fmt: 'json',
          type: 'total',
          tmcl: uefaChampionsLeague2025,
          ...payload
        }).map(([key, val]) => `${key}=${val}`)

        const statData: GetUefaApiCallRequest = {
          url: `standings/{outletAuthKey}?${statQueries.join('&')}`
        }

        const [statResponse, teamsResponse] = await Promise.all([
          errorHandler(() => getters[UEFA_GETTER.API].getUefaApiCall({
            ...rootGetters[API_GETTER.PARAMS],
            ...statData
          })),
          errorHandler(() => getters[UEFA_GETTER.API].getUefaApiCall({
            ...rootGetters[API_GETTER.PARAMS],
            ...teamsData
          }))
        ])

        return {
          ...statResponse,
          data: {
            ...statResponse.data,
            teams: teamsResponse.data.contestant
          }
        }
      }
    }
  }
}
